import React from 'react';
import ButtonWrapper from './Button';
import { useNavigate } from 'react-router-dom';
import useModal from '../../../../../hooks/useModal';
import DialogWrapper from '../../../../custom-ui/dialog/Dialog';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import CopyExistingJob from './CopyExistingJob';

const AddNewJobModal = ({ jobList, toggle,isShowing }: any) => {
    const navigate = useNavigate();

    const { isShowing: isShowCopyExistingJobModal, toggle: toggleIsShowCopyExistingJobModal } = useModal();

    const jobsListToClone = jobList?.filter((job: any) => job?.jobState !== "draft") || [];

    return (
        <><div>
        { isShowing&&   <DialogWrapper title='' size='w-[46vw]' onClose={() => null}>
                <>
                    <div className="w-full sticky top-0 bg-white z-10   flex justify-between items-center ">
                        <h1 className="text-instant-teams-blue-Main text-xl font-semibold"> Add New Job</h1>
                        <div
                            className="flex justify-center items-center w-7 h-7 bg-gray-100 rounded-full cursor-pointer"
                            onClick={() => toggle()}
                        >
                            <FontAwesomeIcon icon={faTimes} color="#565656" />
                        </div>
                    </div>
                    <hr className="border-gray-300  my-4" />

                    <div className='grid grid-cols-2 h-[30vh] mt-8 mb-5 gap-4'>
                        <div
                            onClick={() => {
                                toggle();
                                navigate('/jobs/new');
                            }}
                            className='  flex justify-center flex-col items-center  border  border-gray-300 hover:border-instant-teams-blue-Main hover:border-2 p-4 cursor-pointer rounded-lg'>
                            <h1 className=' text-center text-instant-teams-blue-Main text-2xl  font-semibold'>
                                Post New Job
                            </h1>
                            <p className='text-center text-sm text-instant-teams-blue-Main'>To post a new job, click here to get started.</p>
                        </div>
                        <div
                            onClick={() => {
                                if (jobsListToClone?.length <= 0) {
                                    return null
                                }
                                  toggleIsShowCopyExistingJobModal();
                                  toggle()
                              
                            }}
                            className={`flex justify-center flex-col items-center border  ${jobsListToClone?.length <= 0 ? "border-gray-200 cursor-not-allowed " : "border-gray-300 hover:border-instant-teams-blue-Main hover:border-2 "}  p-4 cursor-pointer   rounded-lg`}>
                            <h1 className={`text-center ${jobsListToClone?.length <= 0 ? "text-gray-200" : "text-instant-teams-blue-Main "} text-2xl font-semibold`}>
                                Copy Existing Job
                            </h1>
                            <p className={`'text-center text-sm ${jobsListToClone?.length <= 0 ? "text-gray-200" : "text-instant-teams-blue-Main "} '`}>{"Duplicate an existing job listing"}</p>
                        </div>

                    </div>
                    {/* <div className='my-5 mt-8 text-center' >
                        <ButtonWrapper
                            onClick={() => {
                                toggle();
                                navigate('/jobs/new');
                            }}
                        >
                            Continue
                        </ButtonWrapper>
                    </div> */}
                </>

            </DialogWrapper>}

          

        </div>
              {isShowCopyExistingJobModal && (
                <>
                    <CopyExistingJob jobList={jobsListToClone} toggleIsShowCopyExistingJobModal={toggleIsShowCopyExistingJobModal} />
                </>
            )
            }
        </>
        
    );
}

export default AddNewJobModal;
